interface LangOptions {
	from: string;
	to: string;
}

export const lang = {
	changePlan: {
		title: 'Change your plan anytime',
		message: 'You can upgrade or cancel your plan anytime from your account page',
		lifetimeMessage:  'You can upgrade your plan anytime from your account page'
	},
	moneyBack: {
		title: '30-day money back guarantee',
		// message: ({ from, to }: LangOptions) => `from ${from} to ${to}` TODO restore after BF
		message: ({ from, to }: LangOptions) =>
			`Applies from when you start coding, even if that's not until ${new Date().getFullYear() +
				1}`
	},
	moneyBackRedeemed: {
		title: '30-day money back guarantee',
		message: `Applies for 30 days after plan is redeemed`
	},
	cancelAnytime: {
		title: 'Cancel anytime',
		message: `Your plan renews each month`
	},
	coupons: {
		title: "No need to search for coupon codes",
		message: `We believe every customer should get the best price available so you won't find any discount codes online`
	}
};
